module.exports = __webpack_public_path__ + "static/img/logo_UGent_EN_RGB_2400_white_cropped.af3bfac5.png";